import { FormTextField } from '../../hook-form-connectors/form-text-field'
import React from 'react'

export const LinkExternoItem = ({ link, index }) => {
  return (
    <div className='flex flex-col gap-mili border rounded-md p-mili'>
      <span className='text-centi'>{link.label ?? 'Sem label'}</span>

      <div className='flex gap-mili'>
        <FormTextField
          name={`linksExternos.${index}.uriHomolog`}
          label='URI Homolog'
        />
        <FormTextField
          name={`linksExternos.${index}.uri`}
          label='URI Produção'
          disabled
        />
      </div>
    </div>
  )
}
